import apic from './apic';
import micro from './apic/micro';
import dojoTheme from './dojo-theme';
export const fullTheme = {
    theme: Object.assign({}, dojoTheme.theme, apic.theme),
    variants: {
        ...dojoTheme.variants,
        ...apic.variants
    }
};
export const microTheme = {
    theme: Object.assign({}, dojoTheme.theme, micro.theme),
    variants: {
        ...dojoTheme.variants,
        ...micro.variants
    }
};
export default fullTheme;
